import { render, staticRenderFns } from "./sxjd.vue?vue&type=template&id=ce454c88&scoped=true"
import script from "./sxjd.vue?vue&type=script&lang=js"
export * from "./sxjd.vue?vue&type=script&lang=js"
import style0 from "./sxjd.vue?vue&type=style&index=0&id=ce454c88&prod&scoped=true&lang=less"
import style1 from "./sxjd.vue?vue&type=style&index=1&id=ce454c88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce454c88",
  null
  
)

export default component.exports